export { default as RectangleSelector } from './hocs/RectangleSelector'
export { default as PointSelector } from './hocs/PointSelector'
export { default as OvalSelector } from './hocs/OvalSelector'
export { default as PolygonSelector } from './hocs/PolygonSelector'



// WEBPACK FOOTER //
// ./src/selectors.js